import script from "./ReviewsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewsSection.vue?vue&type=script&setup=true&lang=js"

import "./ReviewsSection.vue?vue&type=style&index=0&id=659c799a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-659c799a"]])

export default __exports__